module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_pp1_6005.49bf45cc.png";